import { DropdownProps, SelectOptionType } from "src/VirtualOMS/types/common";
import Dropdown from ".";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

interface IProps extends DropdownProps {
  fetchData: (refresherValue?: any) => Promise<any>;
  refresherValue?: any;
}

const DynamicDropdown = ({
  fetchData,
  refresherValue,
  floating,
  onIsOpenChange,
  onSelectedOptionChange,
  placeholder,
  selectedOption,
  title,
}: IProps) => {
  const [options, setOptions] = useState([] as SelectOptionType[]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(false);
    fetchData(refresherValue)
      .then(setOptions)
      .catch(() => toast.error("Something went wrong!"))
      .finally(() => setLoading(false));
  }, [refresherValue]);

  return (
    <Dropdown
      options={options}
      floating={floating}
      onIsOpenChange={onIsOpenChange}
      onSelectedOptionChange={onSelectedOptionChange}
      placeholder={placeholder}
      selectedOption={selectedOption}
      title={title}
    />
  );
};

export default DynamicDropdown;
